"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagName = exports.FeatureFlagValue = void 0;
var FeatureFlagValue;
(function (FeatureFlagValue) {
    FeatureFlagValue["Control"] = "Control";
    FeatureFlagValue["A"] = "A";
    FeatureFlagValue["B"] = "B";
    FeatureFlagValue["C"] = "C";
    FeatureFlagValue["D"] = "D";
    FeatureFlagValue["E"] = "E";
    FeatureFlagValue["F"] = "F";
    FeatureFlagValue["G"] = "G";
})(FeatureFlagValue || (exports.FeatureFlagValue = FeatureFlagValue = {}));
var FeatureFlagName;
(function (FeatureFlagName) {
    FeatureFlagName["Test"] = "Test";
    FeatureFlagName["IsFundraiserFormEditDisabled"] = "IsFundraiserFormEditDisabled";
    FeatureFlagName["IsPaymentByPadAllowed"] = "IsPaymentByPadAllowed";
    FeatureFlagName["IsZeffyUnderAttackFromCardTesting"] = "IsZeffyUnderAttackFromCardTesting";
    FeatureFlagName["IsAuctionRebiddingDisabled"] = "IsAuctionRebiddingDisabled";
    FeatureFlagName["CheckPhishingScoreWithOpenAI"] = "CheckPhishingScoreWithOpenAI";
    FeatureFlagName["ForceCheckPhishingScoreWitheOpenAI"] = "ForceCheckPhishingScoreWitheOpenAI";
    FeatureFlagName["BlockEmailsOnRecipientSuspiciousActivity"] = "BlockEmailsOnRecipientSuspiciousActivity";
    FeatureFlagName["BlockOwnerEmailChangeFromForeignRegion"] = "BlockOwnerEmailChangeFromForeignRegion";
    FeatureFlagName["RecaptchaIsDeactivated"] = "RecaptchaIsDeactivated";
    FeatureFlagName["IsOrganizationLoadTestEnabled"] = "IsOrganizationLoadTestEnabled";
    FeatureFlagName["IsApplePayGooglePayEnabledOnEmbed"] = "IsApplePayGooglePayEnabledOnEmbed";
    FeatureFlagName["RepeatDonorZeroTipLowSuggestionsV4Under250"] = "RepeatDonorZeroTipLowSuggestionsV4Under250";
    FeatureFlagName["RepeatDonorZeroTipLowSuggestionsV4Over250"] = "RepeatDonorZeroTipLowSuggestionsV4Over250";
    FeatureFlagName["RepeatDonorTippedLastDonationUiV1"] = "RepeatDonorTippedLastDonationUiV1";
    FeatureFlagName["RepeatDonorLowTipOver250V1"] = "RepeatDonorLowTipOver250V1";
    FeatureFlagName["TipSuggestionLargeGift1001To2500V1"] = "TipSuggestionLargeGift1001To2500V1";
    FeatureFlagName["AutoActivateSms"] = "AutoActivateSms";
    FeatureFlagName["UnderPhishingAttack"] = "UnderPhishingAttack";
    FeatureFlagName["AddRecentOrganizationCreationUnderPhishingAttackCondition"] = "AddRecentOrganizationCreationUnderPhishingAttackCondition";
    FeatureFlagName["AddOnlyTransactionReceiptUnderPhishingAttackCondition"] = "AddOnlyTransactionReceiptUnderPhishingAttackCondition";
    FeatureFlagName["IsDashboardClickAutocaptureEnabled"] = "IsDashboardClickAutocaptureEnabled";
    FeatureFlagName["CommunicationsActivationChecklist"] = "CommunicationsActivationChecklist";
    FeatureFlagName["DonorAssistant"] = "DonorAssistant";
    FeatureFlagName["OrganizationAssistant"] = "OrganizationAssistant";
    FeatureFlagName["PublicAssistant"] = "PublicAssistant";
    FeatureFlagName["EmailDeflectionShadow"] = "EmailDeflectionShadow";
    FeatureFlagName["ListCreationV2"] = "ListCreationV2";
    FeatureFlagName["IsTransactionalEmailCompatibilityWriteDisabled"] = "IsTransactionalEmailCompatibilityWriteDisabled";
    FeatureFlagName["FulfillmentCustomizableTable"] = "FulfillmentCustomizableTable";
    FeatureFlagName["GuestListCustomizableTable"] = "GuestListCustomizableTable";
    FeatureFlagName["EndOfYearChecklist"] = "EndOfYearChecklist";
    FeatureFlagName["VerifiedBadge"] = "VerifiedBadge";
    FeatureFlagName["NeutralPaymentStepMobileFirstTimeDonors"] = "NeutralPaymentStepMobileFirstTimeDonors";
    FeatureFlagName["CollapsedBankRecommendationMobileV1"] = "CollapsedBankRecommendationMobileV1";
    FeatureFlagName["BankFirst250To999V1"] = "BankFirst250To999V1";
    FeatureFlagName["HumanEmailEngagement"] = "HumanEmailEngagement";
})(FeatureFlagName || (exports.FeatureFlagName = FeatureFlagName = {}));
